module.exports = __webpack_public_path__ + "img/6.3ee9d690.jpg";